import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-use-cases',
  templateUrl: './use-cases.component.html',
  styleUrls: ['./use-cases.component.scss']
})
export class UseCasesComponent implements OnInit {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  public tiles: any = [];

  public ngOnInit(): void {
    const useCaseList: any[] = this.activatedRoute.snapshot.data.data;

    useCaseList.forEach((item: any) => {
      item['tags'] = [];
      item['buttonName'] = 'Use This Case';
      item['is_onboarding_track'] = true;
    });
    this.tiles = useCaseList;
  }
}
